import styled, { css } from 'styled-components';
import { BLACK } from '@nokia-csf-uxr/freeform-design-tokens/tokens/colors';
import {
  SPACING_2,
  SPACING_4,
  SPACING_8,
  SPACING_16,
  SPACING_24
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';

import { RADIUS_CIRCLE } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';
import { SHADOW_SPREAD_6, SHADOW_SPREAD_12 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/shadow_spread';
import { NOKIA_PURE_TEXT_BOLD } from '@nokia-csf-uxr/freeform-design-tokens/tokens/fontFamily';
import { FONT_SIZE_14 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/fontSize';
import { BORDER_BOX } from 'common';

const DEFAULT_BOX_SHADOW = `0 ${SHADOW_SPREAD_6} ${SHADOW_SPREAD_6} 0 ${BLACK}3D, 0 0 ${SHADOW_SPREAD_6} 0 ${BLACK}1F`;
const HOVERED_BOX_SHADOW = `0 ${SHADOW_SPREAD_12} ${SHADOW_SPREAD_12} 0 ${BLACK}3D, 0 0 ${SHADOW_SPREAD_12} 0 ${BLACK}1F`;

export const MEDIUM_FAB_HEIGHT = '3.5rem';
export const SMALL_FAB_HEIGHT = '2.5rem';

const SMALL_STYLE = {
  minWidth: SMALL_FAB_HEIGHT,
  height: SMALL_FAB_HEIGHT,
  borderRadius: SMALL_FAB_HEIGHT
};

const MEDIUM_STYLE = {
  minWidth: MEDIUM_FAB_HEIGHT,
  height: MEDIUM_FAB_HEIGHT,
  borderRadius: MEDIUM_FAB_HEIGHT
};

const DEFAULT_POSITION = {
  position: 'fixed',
  right: SPACING_24,
  bottom: SPACING_24
};

const ButtonBorderWrapper = styled.button`
  ${DEFAULT_POSITION}
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  box-shadow: ${DEFAULT_BOX_SHADOW};
  outline: none;
  ${({ size }) => (size === 'small' ? SMALL_STYLE : MEDIUM_STYLE)}
  ${({ $theme, $rtl, keyDown }) => `
    direction: ${$rtl ? 'rtl' : 'ltr'};
    background: ${!keyDown ? $theme.background : $theme.keyDown.background};
    &:focus {
      box-shadow: ${keyDown ? HOVERED_BOX_SHADOW : DEFAULT_BOX_SHADOW}, inset 0 0 0 ${SPACING_2} ${$theme.focus.border};
    }
    ${
  keyDown
    ? `
       * div{
          color: ${$theme.hover.content}
        }
    `
    : ''
}
    &:hover {
      box-shadow: ${HOVERED_BOX_SHADOW};
      background: ${$theme.hover.background};
      * {
        color: ${$theme.hover.content};
      }
      svg * {
        fill: ${$theme.hover.content};
      }
    }
    &:hover&:focus {
      box-shadow: ${HOVERED_BOX_SHADOW}, inset 0 0 0 ${SPACING_2} ${$theme.focus.border};
    }
    &:active {
      box-shadow: ${HOVERED_BOX_SHADOW};
      background: ${!keyDown ? $theme.active.background : $theme.keyDown.background};
    }
    &:active&:focus {
      box-shadow: ${HOVERED_BOX_SHADOW}, inset 0 0 0 ${SPACING_2} ${$theme.focus.border};
    }
  `};
`;

export default {
  ButtonBorderWrapper,
  RippleContainer: styled.div`
    ${BORDER_BOX}
    position: relative;
    ${({ small }) =>
    css`
        padding: 0 ${small ? SPACING_8 : SPACING_16};
      `}
    width: 100%;
    height: 100%;
    border-radius: ${RADIUS_CIRCLE};
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  IconContainer: styled.div`
    display: flex;
    z-index: 0;
    & > * {
      margin: auto;
    }
    ${({ $theme }) =>
    css`
        & svg * {
          fill: ${$theme.content};
        }
      `}
  `,
  TextContainer: styled.div`
    ${BORDER_BOX}
    padding: 0 ${SPACING_4};
    z-index: 1;
    user-select: none;
    font-family: ${NOKIA_PURE_TEXT_BOLD};
    font-size: ${FONT_SIZE_14};
    text-transform: uppercase;
    ${({ $theme, $rtl }) =>
    css`
        direction: ${$rtl ? 'rtl' : 'ltr'};
        color: ${$theme.content};
      `}
  `
};
